import { useEffect, useState } from "react";
import useCustomTranslation from "./useCustomTranslation";
import { FILTER_TABS } from "./config";

export function useFilterTabs(unreadMsgCount, timeoutDelay = 0) {
    const { t } = useCustomTranslation();

    const [filteredTabs, setFilteredTabs] = useState([
        { name: t("constantString.filter_tab_unread"), isSelected: true },
        { name: t("constantString.all"), isSelected: false },
    ]);

    useEffect(() => {
        const timer = setTimeout(() => {
            const hasUnread = unreadMsgCount && unreadMsgCount > 0;

            const tabs = [];

            if (hasUnread) {
                tabs.push({
                    name: t("constantString.filter_tab_unread"),
                    isSelected:
                        filteredTabs?.find((t) => t.name === FILTER_TABS.UNREAD)?.isSelected ||
                        false,
                });
            }

            tabs.push({
                name: t("constantString.all"),
                isSelected:
                    filteredTabs?.find((t) => t.name === FILTER_TABS.ALL)?.isSelected || !hasUnread,
            });

            // If no tab is selected, make "All" selected
            if (!tabs.some((tab) => tab.isSelected)) {
                tabs.forEach((tab) => {
                    tab.isSelected = tab.name === FILTER_TABS.ALL;
                });
            }

            setFilteredTabs(tabs);
        }, timeoutDelay);

        return () => clearTimeout(timer);
    }, [unreadMsgCount, timeoutDelay]);

    const selectType = (index) => {
        const updatedTabs = filteredTabs.map((tab, idx) => ({
            ...tab,
            isSelected: idx === index,
        }));
        setFilteredTabs(updatedTabs);
    };

    return { filteredTabs, selectType };
}
